"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDF_JOB_ACTION_FATAL_ERROR = exports.isQuebecPrintFormat = exports.isSummaryPrintFormat = exports.isSummaryPartnersPrintFormat = exports.isAuthorizationPrintFormat = exports.QUEBEC_PRINT_FORMATS = exports.SUMMARY_PRINT_FORMATS = exports.SUMMARY_PARTNERS_PRINT_FORMATS = exports.AUTHORIZATION_PRINT_FORMATS = exports.PRINT_FORMATS = void 0;
var PRINT_FORMATS;
(function (PRINT_FORMATS) {
    PRINT_FORMATS["authorizationToSignCanada"] = "authorizationToSignCanada";
    PRINT_FORMATS["authorizationToSignQuebec"] = "authorizationToSignQuebec";
    PRINT_FORMATS["summaryCanada"] = "summaryCanada";
    PRINT_FORMATS["summaryQuebec"] = "summaryQuebec";
    PRINT_FORMATS["summaryPartnersCanada"] = "summaryPartnersCanada";
    PRINT_FORMATS["summaryPartnersQuebec"] = "summaryPartnersQuebec";
})(PRINT_FORMATS = exports.PRINT_FORMATS || (exports.PRINT_FORMATS = {}));
exports.AUTHORIZATION_PRINT_FORMATS = [
    `${PRINT_FORMATS.authorizationToSignCanada}`,
    `${PRINT_FORMATS.authorizationToSignQuebec}`,
];
exports.SUMMARY_PARTNERS_PRINT_FORMATS = [
    `${PRINT_FORMATS.summaryPartnersCanada}`,
    `${PRINT_FORMATS.summaryPartnersQuebec}`,
];
exports.SUMMARY_PRINT_FORMATS = [
    `${PRINT_FORMATS.summaryCanada}`,
    `${PRINT_FORMATS.summaryQuebec}`,
    ...exports.SUMMARY_PARTNERS_PRINT_FORMATS,
];
exports.QUEBEC_PRINT_FORMATS = [
    `${PRINT_FORMATS.summaryQuebec}`,
    `${PRINT_FORMATS.summaryPartnersQuebec}`,
    `${PRINT_FORMATS.authorizationToSignQuebec}`,
];
function isAuthorizationPrintFormat(format) {
    return exports.AUTHORIZATION_PRINT_FORMATS.includes(format);
}
exports.isAuthorizationPrintFormat = isAuthorizationPrintFormat;
function isSummaryPartnersPrintFormat(format) {
    return exports.SUMMARY_PARTNERS_PRINT_FORMATS.includes(format);
}
exports.isSummaryPartnersPrintFormat = isSummaryPartnersPrintFormat;
function isSummaryPrintFormat(format) {
    return exports.SUMMARY_PRINT_FORMATS.includes(format);
}
exports.isSummaryPrintFormat = isSummaryPrintFormat;
function isQuebecPrintFormat(format) {
    return exports.QUEBEC_PRINT_FORMATS.includes(format);
}
exports.isQuebecPrintFormat = isQuebecPrintFormat;
exports.PDF_JOB_ACTION_FATAL_ERROR = 'pdfJobFatalError';
//# sourceMappingURL=printPdf.js.map